import { useCurrentOrg } from '@/app/entities/org/model'
import { addCompetition, type AddCompetitionRequest, type AddCompetitionResponse } from '../api'
import { useFormMutation } from '@/common/hooks/useFormMutation'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'

export const useCompetitionModal = () => {
    const { data: currentOrg } = useCurrentOrg()
    const navigate = useNavigate()
    const queryClient = useQueryClient()

    const validateProductMutation = useFormMutation<
        AddCompetitionRequest,
        AddCompetitionResponse,
        {
            detail?: string
            field_errors?: Record<keyof AddCompetitionRequest, string>
        }
    >({
        mutationFn: (data: AddCompetitionRequest) => addCompetition(currentOrg?.id as string, data),
        toastOptions: {
            successMessage: 'Анализ запущен',
        },
    })

    const { form, handleSubmit, onSubmit, register, errors } = useFormMutation<
        AddCompetitionRequest,
        AddCompetitionResponse,
        {
            detail?: string
            field_errors?: Record<keyof AddCompetitionRequest, string>
        }
    >({
        mutationFn: (data: AddCompetitionRequest) => addCompetition(currentOrg?.id as string, data),
        toastOptions: {
            successMessage: 'Анализ запущен',
            errorMessage: 'Ошибка при анализе',
        },
        onSuccess: (data: AddCompetitionResponse) => {
            queryClient.invalidateQueries({ queryKey: ['products-infinite'] })
            navigate(`/app/products/${data.additional_info?.product_id}`)
        },
        onError: () => {},
    })

    return {
        form,
        onSubmit,
        register,
        errors,
        handleSubmit,
        isSubmitting: validateProductMutation.mutation.isPending,
        submitError: validateProductMutation.error,
        isSubmitSuccess: validateProductMutation.isSuccess,
    }
}
